module.exports = __webpack_public_path__ + "static/assets/GlacialIndifference-Regular.bb6da54e.woff2";